/**
 * Private page scripts.
 *
 * @module Private
 */

import CommonSubPage from './_CommonSubPage';

export default class Private extends CommonSubPage {}




// WEBPACK FOOTER //
// ./src/js/pages/private.js